// extracted by mini-css-extract-plugin
module.exports = {"LanguageToggle":"LanguageToggle___3_seQ","ButtonsWrap":"ButtonsWrap___WMP06","IsActive":"IsActive___3IBd1","ToggleText":"ToggleText___31pVD","loading":"loading___3MKD5"};